import QuickQuotePrice from './QuickQuotePrice'

export default QuickQuotePrice
